import { http } from "./http";

export interface BackupReport {
  repository: { available: boolean; branch: string | null; head: string | null };
  uploads: { available: boolean; directories: Record<string, number> };
  database: { available: boolean; generated_at: string | null; bytes: number; path: string };
  excluded: string[];
}

const base = () => import.meta.env.VITE_API_URL ?? "/api";

export const backupService = {
  /** O que existe hoje para entrar no backup do projeto. */
  inspect: (projectId: string) => http.get<BackupReport>(`/projects/${projectId}/backup`),

  /** Pede ao runner um dump novo do banco de desenvolvimento do sandbox. */
  dumpDatabase: (projectId: string) =>
    http.post<{ command_id: string; status: string }>(`/projects/${projectId}/backup/database`, {}),

  /** URL do download do backup (autenticado por cookie de sessão). */
  downloadUrl: (projectId: string) => `${base()}/projects/${projectId}/backup/download`,
};
